import "core-js/modules/es6.function.name";

/** @jsx _j **/

/** @jsxFrag _f **/
var _require = require('astroturf'),
    _j = _require.jsx,
    _f = _require.F;

import renderProps from '@docpocalypse/props-table';
import PropDescription from './PropDescription';
export { renderProps };

var tokenMap = require('./PropsTable-tokenMap.module.css');
/** @public */


function PropsTable(_ref) {
  var metadata = _ref.metadata;
  var props = renderProps(metadata.props || [], {
    tokenMap: tokenMap
  });

  if (!props.length) {
    return null;
  }

  return _j(_f, null, _j("table", {
    css: [require("./PropsTable-CssProp1_table.module.css"), []]
  }, _j("thead", null, _j("tr", null, _j("th", null, "Name"), _j("th", null, "Type"), _j("th", null, "Default"), _j("th", null, "Description"))), _j("tbody", null, props.map(function (prop) {
    var _prop$propData$descri;

    return _j("tr", {
      key: prop.name
    }, _j("td", null, prop.name), _j("td", {
      className: "font-mono whitespace-pre"
    }, prop.type), _j("td", {
      className: "font-mono whitespace-pre"
    }, prop.defaultValue), _j(PropDescription, {
      as: "td",
      html: prop.description,
      mdx: (_prop$propData$descri = prop.propData.description) === null || _prop$propData$descri === void 0 ? void 0 : _prop$propData$descri.mdx
    }));
  }))));
}

export var metadataFragment = "113111848";
export default PropsTable;